import { UserSuccessModalComponent } from './components';
import { useUserSuccessModalFacade } from './user-success-modal.facade';

type Props = {
  isOpen?: boolean;
  onClose?: () => void;
  /**
   * us-lpのURLに付与するGA計測用のパラメーター
   * utm_sourceはfindy-code, utm_mediumはsiteで固定
   */
  utmCampaign?: string;
};

export const UserSuccessModal = ({
  isOpen = false,
  onClose,
  utmCampaign,
}: Props) => {
  const { setLastShownAt } = useUserSuccessModalFacade();
  return (
    <UserSuccessModalComponent
      isOpen={isOpen}
      utmCampaign={utmCampaign}
      onAfterOpen={setLastShownAt}
      onClose={onClose}
    />
  );
};
